import route from 'hooks/route';
import {
  clientDeskAccessConfig,
  clientDeskAndSurepvisorConfig,
} from '../constants/accesses';
import React from 'react';

export enum UsersRouteTypes {
  NEW = 'new',
  ACTIVE = 'active',
  DEACTIVATED = 'deactivated',
  UNCONFIRMED = 'unconfirmed',
  ADMINS = 'admins',
}

export type UsersRouteProps = {
  type: UsersRouteTypes;
  id?: string;
};

export enum UsersRoutePath {
  signin = '/signin',
  resetPassword = '/restore-password',
  checkEmail = '/check-email',
  users = '/users',
}

export const SignInRoute = route({
  path: UsersRoutePath.signin,
  component: React.lazy(() => import('pages/signin/index')),
});

export const ResetPasswordRoute = route({
  path: UsersRoutePath.resetPassword,
  component: React.lazy(() => import('pages/signin/ResetPasswordPage')),
});

export const CheckEmailRoute = route({
  path: UsersRoutePath.checkEmail,
  component: React.lazy(() => import('pages/signin/CheckEmail')),
});

export const RootUsersRoute = route({
  path: UsersRoutePath.users,
  component: React.lazy(() => import('pages/users/main')),
  accessConfig: clientDeskAndSurepvisorConfig,
});

export const UsersRoute = route<UsersRouteProps>({
  path: '/users/:type',
  component: React.lazy(() => import('pages/users/main')),
  accessConfig: clientDeskAndSurepvisorConfig,
});

export const CustomerProfileRoute = route<UsersRouteProps>({
  path: '/users/:type/:id/profile',
  component: React.lazy(() => import('pages/users/customer/profile')),
  accessConfig: clientDeskAndSurepvisorConfig,
});

export const CustomerBullingRoute = route<UsersRouteProps>({
  path: '/users/:type/:id/billing',
  component: React.lazy(() => import('pages/users/customer/billing')),
  accessConfig: clientDeskAndSurepvisorConfig,
});

export const CustomerPlansRoute = route<UsersRouteProps>({
  path: '/users/:type/:id/plans',
  component: React.lazy(() => import('pages/users/customer/plans')),
  accessConfig: clientDeskAndSurepvisorConfig,
});

export const CustomerDownloadsRoute = route<UsersRouteProps>({
  path: '/users/:type/:id/downloads',
  component: React.lazy(() => import('pages/users/customer/downloads')),
  accessConfig: clientDeskAccessConfig,
});

export const CustomerMembersRoute = route<UsersRouteProps>({
  path: '/users/:type/:id/members',
  component: React.lazy(() => import('pages/users/customer/members')),
  accessConfig: clientDeskAndSurepvisorConfig,
});

export const CustomerPurchasesRoute = route<UsersRouteProps>({
  path: '/users/:type/:id/purchases',
  component: React.lazy(() => import('pages/users/customer/purchases')),
  accessConfig: clientDeskAndSurepvisorConfig,
});

export const CustomerRoute = route<UsersRouteProps>({
  path: '/users/:type/:id',
  component: React.lazy(() => import('pages/users/customer')),
});
